import getApolloClient from './client';

// Apollo client singleton, extracted from `entry.client.tsx` so that modules
// which only need `client` don't drag Sentry/hydrate bootstrap code into
// their import graph (e.g. Storybook/Vitest dependency scans).
// eslint-disable-next-line import/prefer-default-export
export const client = getApolloClient();
